/* eslint-disable max-len */
import { Breadcrumbs } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getFolder } from '../../../../../../../actions/media_actions';
import { catchErr } from '../../../../../../../../libs/HelperContent';
import { BsFolder } from 'react-icons/bs';
import { LanguageContext } from '../../../../../../../../libs/Context';

const MediaDriveBreadCrumbs = (props) =>
{
	const { page, footerActn, folderId, setCount, setLoading, foldersData, setFoldersData, loaderRef, breadCrumbs, handleFolder,
		setBreadCrumbs } = props;
	const language = useContext(LanguageContext);
	const userData = useSelector((state:any) => state.mysession.session);
	const query: any = {
		uid     : userData?.userId,
		comid   : userData?.companyId,
		empRole : userData?.empRole,
		role    : userData?.role,
		limit   : 12,
		skip    : page
	};

	const getFoldersCount = async () =>
	{
		Object.assign(query, { count: true });
		const response = getFolder(query, 'folders');

		try
		{
			const res = await response;

			if (res?.status)
			{
				setCount(res?.count);
			}
		}
		catch (err)
		{
			catchErr(err);
		}
	};

	const getFoldersData = async () =>
	{
		// const imgDocs = footerActn === 'application' ? [ 3, 1 ] : [ 2, 1 ];

		query.mediaType = JSON.stringify(footerActn === 'image_video' ? [ 5, 1, 3 ] : [ 2, 1 ]);

		if (folderId?.current !== '')
		{
			query.id = folderId.current;
		}
		setLoading(page === 0);

		try
		{
			const res = await getFolder(query, 'folders');

			if (res?.status)
			{
				if (page === 0)
				{
					res?.data?.length >= 10 ? getFoldersCount() : setCount(res?.data?.length);
				}
				setFoldersData(page === 0 ? res?.data : [ ...foldersData, ...res.data ]);
			}
			else
			{
				setFoldersData(foldersData || []);
			}
		}
		catch (err)
		{
			catchErr(err);
		}
		finally
		{
			setLoading(false);
			loaderRef.current = false;
		}
	};

	const handleKeyUp = (e, index, breadCrumb) =>
	{
		if (e.key === 'Enter')
		{
			if (index + 1 !== breadCrumbs?.length)
			{
				handleFolder(breadCrumb);
			}
		}
	};

	useEffect(() =>
	{
		getFoldersData();
	}, [ page, folderId?.current ]);

	return (
		<Breadcrumbs
			maxItems={2}
			itemsAfterCollapse={1}
			aria-label='breadcrumb'
			className='flexWrap alignCntr navWidth'
		>
			{folderId?.current &&
			<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleFolder(''); setBreadCrumbs([]); }}
				className='flexInline alignStart breadCrumbTxt pointer headingSM'
				onClick={() => { handleFolder(''); setBreadCrumbs([]); }}
			>
				<BsFolder fontSize={'var(--pixel24)'} className='primaryTxt mrgnRXS' />
				{language.main}
			</button>}
			{breadCrumbs?.map((breadCrumb, index) => (
				<button tabIndex={0} onKeyUp={(e) => handleKeyUp(e, index, breadCrumb)}
					key={breadCrumb?.folderId}
					id={breadCrumb?.folderId}
					onClick={
						index + 1 !== breadCrumbs?.length
							? () => handleFolder(breadCrumb)
							: () => {}
					}
					className={`flexInline mediakit-breadcumb headingSM ${
						index !== breadCrumbs?.length - 1
							? ' breadCrumbTxt pointer'
							: 'lightTxt'
					}`}
				>
					{breadCrumb?.name?.length > 50
						? `${breadCrumb?.name?.slice(0, 50)}...`
						: breadCrumb?.name}
				</button>
			))}
		</Breadcrumbs>
	);
};

export default MediaDriveBreadCrumbs;